<p class="spl-ui-tagline">Split expenses. Track balances. Settle up.</p>
